import { getItem, setItem } from '@/helpers/storage';

export const isCurrentProfile = (profile) => getItem('currentProfile')?.profile_number === profile.profile_number;

export const saveCurrentProfile = (profile) => setItem('currentProfile', profile);
